module.exports = __webpack_public_path__ + "static/media/lscreen-en.3c002e15.png";